import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-time-menu-toggle',
  templateUrl: './time-menu-toggle.component.html',
  styleUrls: ['./time-menu-toggle.component.scss']
})
export class TimeMenuToggleComponent implements OnInit {

  @Input() activeSideMenu: any;
  @Input() gisMapComp: any
  is24Active;
  iscurrentActive;
  is10Active;
  moduleName: any;
  componentName: any;
  notDesktop: boolean = true;
  adminSelected: boolean = true;
  ruralSelected: boolean = true;
  stateUrlId: string = 'akbm';
  sourceSelected: string = 'IMD';
  isWeeklyActive: boolean = false;

  constructor(private utils: UtilsService, private router: Router, private http: HttpClient, private route: ActivatedRoute) { }

  ngOnInit() {
    this.moduleName = this.router.url.split('/')[1];
    this.componentName = this.router.url.split('/')[2];
    this.route.queryParamMap.subscribe(async (params: Params) => {
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          switch (params[param]['forecastLength']) {
            case '24': this.is24Active = true; this.is10Active = false; break;
            case '10': this.is10Active = true; this.is24Active = false; break;
          }
        }
      }
    })
  }

  routeChange(time) {
    // call utils service to call route changed
    // this.utils.setForecastLengthChanged(time);
    let moduleName: any = this.router.url.split('/')[1];
    const componentName = this.router.url.split('/')[2];
    // let stateId = (moduleName != 'thunderstorms' || moduleName != 'weatherforecast') ? this.router.url.split('/')[4] : this.router.url.split('/')[3];
    let stateId = (moduleName === 'thunderstorms' || moduleName === 'weatherforecast') ? this.router.url.split('/')[3] : this.router.url.split('/')[4];
    let options = { ...this.gisMapComp.queryParams['params'] }
    options['forecastLength'] = time
    // if (moduleName != 'thunderstorms' || moduleName != 'weatherforecast') {
    //   this.router.navigate([moduleName, componentName, time, stateId]);
    // } else {
    //   this.gisMapComp['router'].navigate(['/' + this.gisMapComp.routeParams.dashboard + '/' + this.gisMapComp.componentType + '/akbm'], {
    //     relativeTo: this.gisMapComp['route'],
    //     queryParams: options,
    //     queryParamsHandling: 'merge'
    //   });
    // }
    if (moduleName === 'thunderstorms' || moduleName === 'weatherforecast') {
      this.gisMapComp['router'].navigate(['/' + this.gisMapComp.routeParams.dashboard + '/' + this.gisMapComp.componentType + '/akbm'], {
        relativeTo: this.gisMapComp['route'],
        queryParams: options,
        queryParamsHandling: 'merge'
      });
    } else {
      this.router.navigate([moduleName, componentName, time, stateId]);
    }
    switch (time) {
      case '24': this.is24Active = true; this.is10Active = false; break;

      case '10': this.is24Active = false; this.is10Active = true; break;
    }
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
  }

  ruralUrbanToggle() {
    this.ruralSelected = !this.ruralSelected;
  }

}
